window.addEventListener("load", () => {
  const one_tap_checkbox = document.getElementById(
    "one-tap-email-optin-checkbox"
  );
  if (one_tap_checkbox) {
    one_tap_checkbox.addEventListener("change", event => {
      const target = event.currentTarget;
      if (target.parentElement) {
        if (target.checked) {
          target.parentElement.setAttribute("data-checked", "true");
        } else {
          target.parentElement.removeAttribute("data-checked");
        }
      }
    });
  }
});
